import {
  Component, ElementRef, HostListener, inject, OnInit, signal,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import {
  ActivatedRoute, RouterModule, RouterOutlet, Router,
} from '@angular/router';
import {
  FormBuilder, FormControl, FormGroup, Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule, AsyncPipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { Observable, of, Subject } from 'rxjs';
import {
  catchError,
  debounceTime,
  filter,
  map, retry, startWith, switchMap, takeUntil,
} from 'rxjs/operators';
import { AuthenticationResult } from '@azure/msal-browser';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatIconModule } from '@angular/material/icon';
import { MsalService } from '@azure/msal-angular';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { DefaultGlobalConfig } from 'ngx-toastr';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ApiServicesService } from './services/api-services.service';
import { GisService, AddressComponents, GISResponse } from './services/gis-service.service';
import { environment } from '../environment/environment';
import { VersionToggleService } from './services/version-toggle/version-toggle.service';
import { KmtService } from './services/kmt/kmt.service';
import { MaintenanceBannerComponent } from './components/maintenance-banner/maintenance-banner.component';
import {
  AddresResponse, FormData, BulkPickResultConditional, TransformedData,
  RawData,
  AddresResponseResult,
  ParallelResultItem,
  Daum,
  FeedBackStatus,
  MpuResponseBase,
  ServiceChangeResponseBase,
  V2ServiceChangeResponse,
  V2AddressComponents,
  V2GisResponse,
  V2BulkResponse,
  V2ExtraPickupResponse,
  V2FeedbackRequest,
  V2ErrorResponse,
  V2BulkResponseUnion,
  V2ExtraPickupResponseUnion,
  V2ServiceChangeResponseUnion,
} from './services/republic.service.type';
import { NgxToastrService } from './services/ngx-toastr.service';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { ExtraPickupService } from './services/extra-pickup/extra-pickup.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    MaintenanceBannerComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatButtonModule,
    AsyncPipe,
    CommonModule,
    MatAutocompleteTrigger,
    MatChipsModule,
    RouterModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ClickOutsideDirective,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})

export class AppComponent implements OnInit {
  @ViewChild('searchButton', { static: false }) searchButton!: ElementRef;

  title = 'aip-km-frontend';

  searchForm: FormGroup;

  unsubscribeAll: Subject<string> = new Subject<string>();

  pickupOptions = [
    { displayName: 'Bulk Pickup', value: 'bulk-pickup' },
    { displayName: 'Extra Pickup', value: 'extra-pickup' },
    // { displayName: 'Missed Pickup', value: 'missed-pickup' },
    { displayName: 'Service Change', value: 'service-change' },
  ];

  containerOptions = [
    { displayName: 'Solid Waste', value: 'Solid Waste' },
    { displayName: 'Recycle', value: 'Recycle' },
  ];

  private gisResponse: GISResponse = {
    polygon: '',
    lawson: '',
    division: '',
    success: false,
  };

  private v2GisResponse: V2GisResponse | null = null;

  gisResolved: boolean = false;

  filteredOptions: Observable<string[]>;

  redirect: boolean;

  countForOutsideClicl: number = 0;

  items: string[] = ['Mattress', 'Microwave', 'Refrigerator', 'Table', 'Couch', 'Chair', 'BBQ Grill', 'Pallet', 'Water Heater', 'Box Spring'];

  extraPickupItems: string[] = ['Trash', 'Recycle', 'Yard Waste'];

  dummyProperty = '';

  addressOptions: Observable<AddresResponse[]>;

  transformedData: TransformedData = { searchResults: {} };

  formWidth: string;

  key: string = 'is_acceptable';

  topLevelItems: string[] = ['is_extra_pickup_available', 'is_acceptable'];

  disabledItems: boolean[] = new Array(this.items.length).fill(false);

  readonly addOnBlur = true;

  llmReqId!: string;

  llmMpuReqId!: string;

  llmScReqId!: string;

  createdOn!: string;

  selectedThumb: string = '';

  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  typeDetails = signal<FormData[]>([]);

  readonly announcer = inject(LiveAnnouncer);

  bulkPickResultConditional: BulkPickResultConditional[];

  jsonUrl: string = '';

  lastSearchType: string | null = null;

  addressList!: Daum[];

  accessToken!: AuthenticationResult;

  address: string;

  feedBackStatus!: FeedBackStatus;

  dynamicKeys: string[] = [];

  isLoading: boolean = false;

  initialFormValue: FormData[];

  iconUrl: string;

  selectionOption: WritableSignal<'bulk-pickup' | 'extra-pickup'> = signal('bulk-pickup');

  showDatePicker: boolean = false;

  showSecondDropdown: boolean = false;

  mpuData: MpuResponseBase | undefined;

  serviceChangeData: ServiceChangeResponseBase | undefined;

  minDate: Date;

  invalidFlag: string | null = null;

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.formWidth = '100%';
  }

  constructor(
    public formBuilder: FormBuilder,
    private api_service: ApiServicesService,
    private msalService: MsalService,
    private http: HttpClient,
    private ngxToastrService: NgxToastrService,
    private activedRoute: ActivatedRoute,
    private router: Router,
    private extraPickupService: ExtraPickupService,
    private gisService: GisService,
    private versionToggleService: VersionToggleService,
    private kmtService: KmtService,
  ) {
    this.searchForm = this.formBuilder.group({
      pickup: new FormControl('bulk-pickup', Validators.required),
      searchTerm: new FormControl('', Validators.required),
      addressterm: new FormControl('', Validators.required),
      date: [''],
      secondDropdown: [''],
    });
    this.iconUrl = environment.icon_url;
    this.formWidth = '100%';
    this.redirect = true;
    const today = new Date();
    today.setDate(today.getDate() - 14);
    this.minDate = today;
    this.filteredOptions = this.searchForm.get('searchTerm')!.valueChanges.pipe(
      startWith(''),
      map(() => this.filterResults()),
    );
    this.bulkPickResultConditional = [];
    // Initialize addressOptions with the Observable
    this.addressOptions = this.searchForm.get('addressterm')!.valueChanges.pipe(
      debounceTime(300),
      filter((value: string) => value.length > 3),
      switchMap((value) => this.addressSearch(value).pipe(
        retry(1), // Retry up to 3 times before failing
        catchError(() => of()),
      )),
    );
    this.initialFormValue = this.typeDetails();
    this.initializeAddressOptions();
    this.address = '';
  }

  isCompleteAddress(address: any): boolean {
    // Example regex pattern for a more flexible address format: street, city, state, and zip
    // This pattern now accounts for extra spaces and optional punctuation
    const addressPattern = /^(.+),\s*(.+),\s*([A-Z]{2}),\s*(\d{5})$/;
    console.log('Checking address:', address);
    console.log('Regex match result:', addressPattern.test(address));
    return addressPattern.test(address);
  }

  isV2Mode(): boolean {
    const isV2 = this.versionToggleService.isV2();
    console.log('AppComponent - isV2Mode:', isV2);
    return isV2;
  }

  convertToV2AddressComponents(addressComponents: AddressComponents): V2AddressComponents {
    return {
      address_line_1: addressComponents.addressLine1,
      address_line_2: addressComponents.addressLine2 || '',
      city: addressComponents.city,
      state: addressComponents.stateCode,
      zip_code: addressComponents.postalCode,
    };
  }

  convertFromV1AddressData(addressData: any): V2AddressComponents {
    return {
      address_line_1: addressData?.addressLine1 || '',
      address_line_2: addressData?.addressLine2 || '',
      city: addressData?.city || '',
      state: addressData?.stateCode || '',
      zip_code: addressData?.postalCode || '',
    };
  }

  // Subscribe to addressOptions where you need to handle the emitted values
  initializeAddressOptions() {
    // Subscribe to addressOptions where you need to handle the emitted values
    this.addressOptions.pipe(
      takeUntil(this.unsubscribeAll),
    ).subscribe((response) => {
      const res = response as unknown as AddresResponseResult;
      const seen = new Set();
      const uniqueue = res.data.filter((item) => {
        const duplicate = seen.has(item.display);
        seen.add(item.display);
        return !duplicate;
      });
      this.addressList = uniqueue;
      console.log(this.addressList.length);
      setTimeout(() => {
        // this.searchForm.get('addressterm')!.valueChanges.pipe(
        //   debounceTime(300),
        //   filter(value => value.length > 3)
        // ).subscribe(value => {
        if (this.addressList.length > 0) {
          // Check if the address is complete
          if (this.isCompleteAddress(this.searchForm.get('addressterm')?.value)) {
            this.checkAddressInList(this.searchForm.get('addressterm')?.value);
          }
        }
        // });
      }, 1500);
    }, (error) => {
      console.log(error);
    });
  }

  clickOutsideAutoComplete(addressList: AddresResponse[]) {
    const addressTermValue = this.searchForm.get('addressterm')?.value;
    if (addressList && addressList.length > 0 && !addressTermValue?.display) {
      const syntaxedAddress = this.parseAddressTerm(addressTermValue);
      if (syntaxedAddress) {
        this.searchForm.patchValue({
          addressterm: syntaxedAddress,
        });
        // Behave as if the address was selected from the autocomplete
        this.onAddressSelected(syntaxedAddress);
      } else {
        // Address format is invalid
        this.openToastrShow('Please enter a valid address format: Street, City, State, ZIP');
      }
    }
  }

  async ngOnInit(): Promise<void> {
    // Subscribe to v2 state changes
    this.versionToggleService.isV2$.subscribe((isV2) => {
      console.log('V2 state changed:', isV2);
    });

    this.activedRoute.queryParams.pipe(debounceTime(1000))
      .subscribe((param) => {
        if (param['address']) {
          this.searchForm.patchValue({
            addressterm: param['address'],
          });
        }
        if (param['AutomationAccessToken']) {
          const token = param['AutomationAccessToken'];
          if (token) {
            const payloadPart = token.split('.')[1];
            try {
              localStorage.setItem('Authorization', token);
              const decodePayload = atob(payloadPart);
              const accessToken = JSON.parse(decodePayload);
              this.accessToken = accessToken.automation_auth;
            } catch (error) {
              console.log(error);
            }
          }
        } else {
          this.getAccessToken();
        }
      });
    this.redirect = true;
    this.formWidth = '100%';
    this.searchForm.get('pickup')?.valueChanges.subscribe((value: string) => {
      if (value === 'missed-pickup') {
        this.searchForm.get('secondDropdown')?.setValidators(Validators.required);
        this.searchForm.get('date')?.setValidators(Validators.required);
        this.searchForm.get('searchTerm')?.clearValidators();
        this.showDatePicker = true;
        this.showSecondDropdown = true;
      } else if (value === 'service-change') {
        this.searchForm.get('secondDropdown')?.clearValidators();
        this.searchForm.get('date')?.clearValidators();
        this.searchForm.get('searchTerm')?.clearValidators();
        this.showDatePicker = false;
        this.showSecondDropdown = false;
      } else {
        this.searchForm.get('secondDropdown')?.clearValidators();
        this.searchForm.get('date')?.clearValidators();
        this.searchForm.get('searchTerm')?.setValidators(Validators.required);
        this.showDatePicker = false;
        this.showSecondDropdown = false;
      }
      this.searchForm.get('secondDropdown')?.updateValueAndValidity();
      this.searchForm.get('date')?.updateValueAndValidity();
      this.searchForm.get('searchTerm')?.updateValueAndValidity();
    });
  }

  async getAccessToken() {
    await this.msalService.instance.initialize();
    await this.msalService.instance.handleRedirectPromise();
    const request = {
      scopes: ['profile'],
      // loginHint: accounts[0].username,
    };
    try {
      const accessToken = await this.msalService.instance.ssoSilent(request);
      if (accessToken) {
        this.accessToken = accessToken;
        localStorage.setItem('Authorization', accessToken.idToken);
      }
      // const accounts = await this.msalService.instance.getAllAccounts();
    } catch {
      await this.msalService.loginPopup().subscribe((token) => {
        if (token) {
          this.accessToken = token;
          localStorage.setItem('Authorization', token.idToken);
        }
      }, (error) => { console.log(error); });
    }
    this.jsonUrl = environment.json_url;
  }

  onPickupOptionChange(event: any) {
    const selectedOption = event.value;
    this.selectionOption.set(selectedOption);
    this.typeDetails.update(() => []);
    if (selectedOption === 'bulk-pickup') {
      this.mpuData = undefined;
      this.disabledItems = new Array(this.items.length).fill(false);
    } else if (selectedOption === 'extra-pickup') {
      this.mpuData = undefined;
      this.disabledItems = new Array(this.extraPickupItems.length).fill(false);
    }
  }

  // async checkLink(url: string) {
  //   console.log('Checking link:', url); // Debugging log

  //   try {
  //     const response = await fetch(url, { method: 'GET', mode: 'no-cors' });
  //     if (response.status == 200 || response.status == 304) {
  //       this.dummyProperty = 'test';
  //     } else {
  //       this.redirect = false;
  //       this.router.navigate(['/error']);
  //     }
  //   } catch (error) {
  //     this.router.navigate(['/error']);
  //   }
  // }

  addressSearch(query: string) {
    return this.api_service.getAddressList(query);
  }

  checkAddressInList(query: any) {
    if (query.length >= 4) {
      console.log(this.addressList);
      const addressExists = this.addressList.some(
        (address) => address.display.toLowerCase() === query.toLowerCase(),
      );
      if (!addressExists) {
        this.openToastrShow('Address not found in Address List');
      } else {
        console.log('exist');
      }
    }
  }

  onKeyDown(event: KeyboardEvent) {
    this.dummyProperty = 'test';
    if (event.key === 'Tab') {
      event.preventDefault(); // Prevent the default tab behavior
      // Ensure the button reference is available and set focus
      const buttonElement = document.getElementById('searchButton') as HTMLButtonElement;
      if (buttonElement) {
        buttonElement.focus();
      }
    }
  }

  static getKeys(obj: string): string[] {
    return obj ? Object.keys(obj) : []; // Safely get keys only if obj is defined
  }

  typeValue(value: string, index: number): void {
    this.disabledItems[index] = true;
    this.typeDetails.update((type) => [...type, { name: value }]);

    if (this.typeDetails().length > 10) {
      this.remove(this.typeDetails()[0]);
    }
    this.searchForm.patchValue({
      searchTerm: this.typeDetails(),
    });
  }

  openToastrShow(message: string) {
    const successIconClass = DefaultGlobalConfig?.iconClasses?.error || '';
    this.ngxToastrService.show(
      message,
      successIconClass,
    );
  }

  searchListSync(itemType: 'bulk-pickup' | 'extra-pickup' | 'missed-pickup' | 'service-change'): void {
    this.isLoading = true;

    // Clear results if the search type is different from the last one
    if (this.lastSearchType && this.lastSearchType !== itemType) {
      this.transformedData = { searchResults: {} };
      this.mpuData = undefined;
      this.serviceChangeData = undefined;
    }

    // Update the last search type
    this.lastSearchType = itemType;

    if (itemType === 'bulk-pickup') {
      this.searchList();
    } else if (itemType === 'extra-pickup') {
      this.searchExtraPickup();
    } else if (itemType === 'service-change') {
      this.searchServiceChange();
    } else {
      this.searchMissedPickup();
    }
  }

  parseAddressTerm(raw: string) {
    this.dummyProperty = 'test';
    // Regular expression to match the expected address format
    const regex = /^(.+),\s*(.+),\s*([A-Z]{2}),\s*(\d{5})$/;
    const match = raw?.match(regex);

    if (match) {
      return {
        addressLine1: match[1].trim(),
        addressLine2: '',
        city: match[2].trim(),
        country: 'USA',
        display: raw.trim(),
        postalCode: match[4].trim(),
        stateCode: match[3].trim(),
      };
    }

    return null; // Return null if the format is incorrect
  }

  addressDisplayFn(address: AddresResponse): string {
    return address && address.display ? address.display : '';
  }

  onAddressSelected(selection: any) {
    const addressComponents: AddressComponents = {
      addressLine1: selection?.addressLine1 || '',
      addressLine2: selection?.addressLine2 || '',
      city: selection?.city || '',
      stateCode: selection?.stateCode || '',
      postalCode: selection?.postalCode || '',
      country: 'USA',
      display: selection?.display || '',
    };

    // Reset GIS state
    this.gisResponse = {
      polygon: '',
      lawson: '',
      division: '',
      success: false,
    };
    this.v2GisResponse = null;
    this.gisResolved = false;

    if (this.isV2Mode()) {
      // Use v2 GIS service
      console.log('Using V2 GIS service');
      const v2AddressComponents = this.convertToV2AddressComponents(addressComponents);

      this.gisService.getV2GISDataFromAddress(v2AddressComponents).subscribe({
        next: (res: V2GisResponse) => {
          this.v2GisResponse = res;
          this.gisResolved = true;
          console.log('V2 GIS ready - Polygon:', res.polygon, 'Lawson:', res.lawson, 'Division:', res.division);
        },
        error: (error) => {
          this.gisResolved = false;
          this.openToastrShow(error.message || 'GIS service error');
        },
      });
    } else {
      // Use v1 GIS service
      console.log('Using V1 GIS service');
      this.gisService.getGISDataFromAddress(addressComponents).subscribe({
        next: (res: GISResponse) => {
          this.gisResponse = res;
          this.gisResolved = res.success;
          if (res.success) {
            console.log('GIS ready - Polygon:', res.polygon, 'Lawson:', res.lawson, 'Division:', res.division);
          } else if (res.error) {
            this.openToastrShow(res.error);
          }
        },
        error: () => {
          this.gisResolved = false;
          this.openToastrShow('GIS service error');
        },
      });
    }
  }

  prepareDataForSearch(): any {
    const addressSelection = this.searchForm.get('addressterm')?.value;
    const addressData = this.parseAddressTerm(addressSelection?.display);
    this.address = this.addressList[0].addressLine1;
    const isDifferent = this.api_service.setAddress(this.searchForm.get('addressterm')?.value);

    // Get newly added items
    const notEqulaValues = [
      ...this.typeDetails().filter((types) => !this.initialFormValue.includes(types)),
    ];

    // Prepare GIS data based on version
    let gisData;
    if (this.isV2Mode() && this.v2GisResponse) {
      gisData = {
        polygon: this.v2GisResponse.polygon,
        lawson: this.v2GisResponse.lawson,
        division: this.v2GisResponse.division,
      };
      console.log('V2 GIS Data:', gisData);
    } else {
      gisData = {
        polygon: this.gisResponse.polygon,
        lawson: this.gisResponse.lawson,
        division: this.gisResponse.division,
      };
      console.log('V1 GIS Data:', gisData);
    }

    const queryParam = {
      ...addressData,
      'search-items': this.typeDetails().map((type) => type.name?.toLowerCase()),
      type: this.searchForm.value.pickup,
      ...gisData,
    };

    // Only show the "already present" message if no new items and address is the same
    if (!isDifferent && !notEqulaValues.length) {
      console.log(this.initialFormValue);
      this.openToastrShow('Search results already present.');
      this.isLoading = false;
      return;
    }

    // Update initialFormValue to current items
    this.initialFormValue = this.typeDetails();
    const searchValue: { [x: string]: { [key: string]: { Generated_Response: string; }; }[]; } = {};
    this.feedBackStatus = {};

    this.searchForm.value.searchTerm.forEach((key: { name: string; }) => {
      if (key && key.name && Object.keys(this.transformedData.searchResults)
        .some((keyName) => keyName === key.name.toLowerCase())) {
        searchValue[key.name.toLowerCase()] = this.transformedData
          .searchResults[key.name.toLowerCase()];
      }
    });

    return {
      queryParam, searchValue, addressData, gisData,
    };
  }

  prepareMissedPickupForSearch(): any {
    const addressSelection = this.searchForm.get('addressterm')?.value;
    const addressData = this.parseAddressTerm(addressSelection?.display);
    const isDifferent = this.api_service.setAddress(this.addressList[0].addressLine1);
    let queryParam = {
      address: addressData?.display,
      date: this.searchForm.get('date')?.value,
      type: this.searchForm.get('secondDropdown')?.value,
    };

    if (isDifferent) {
      queryParam = {
        address: addressData?.display,
        date: this.searchForm.get('date')?.value,
        type: this.searchForm.get('secondDropdown')?.value,
      };
      // Proceed with your search logic here
    }

    this.initialFormValue = this.typeDetails();
    return { queryParam };
  }

  prepareServiceChangeForSearch(): any {
    const addressSelection = this.searchForm.get('addressterm')?.value;
    console.log(addressSelection);
    const addressData = this.parseAddressTerm(addressSelection?.display);
    console.log(addressData);
    return addressData;
    // const isDifferent = this.api_service.setAddress(this.addressList[0].addressLine1);
    // let queryParam = {
    //   address: addressData?.display,
    // };

    // if (isDifferent) {
    //   queryParam = {
    //     address: addressData?.display,
    //   };
    //   // Proceed with your search logic here
    // }

    // this.initialFormValue = this.typeDetails();
    // return { queryParam };
  }

  searchList(): void {
    const {
      queryParam, searchValue, addressData, gisData,
    } = this.prepareDataForSearch();
    console.log(queryParam);

    if (this.isV2Mode()) {
      // Use v2 KMT API for bulk items
      const items = this.typeDetails().map((type) => type.name || '');

      this.kmtService.getBulkItems(
        gisData.polygon,
        gisData.division,
        gisData.lawson,
        items,
      ).pipe(
        takeUntil(this.unsubscribeAll),
      ).subscribe({
        next: (data: V2BulkResponseUnion) => {
          if (this.isV2ErrorResponse(data)) {
            // Handle as error even though it came through 'next'
            this.handleV2Error(data, addressData);
            return;
          }

          if (!this.isV2BulkResponse(data)) {
            this.errorHandling(addressData, { error: { message: 'Invalid response format' } } as HttpErrorResponse);
            return;
          }

          // Existing success handling
          this.isLoading = false;
          console.log('V2 Bulk Response:', data);

          // Transform v2 response to match current UI expectations
          this.transformV2BulkData(data, searchValue);
          this.llmReqId = data?.metadata?.request_id || '';
          this.createdOn = data?.metadata?.created_at || '';
        },
        error: (error) => {
          this.errorHandling(addressData, error);
        },
      });
    } else {
      // Use v1 API
      this.api_service.getItemList(queryParam).pipe(
        takeUntil(this.unsubscribeAll),
      ).subscribe({
        next: (data: any) => {
          if (data) {
            this.isLoading = false;
            const res = data as unknown as RawData;
            this.api_service.transformData(res).subscribe((transformed) => {
              Object.keys(transformed.searchResults).forEach((key) => {
                if (transformed.searchResults[key.toLowerCase()]) {
                  searchValue[key] = transformed.searchResults[key];
                } else {
                  console.log('fail');
                }
              });

              // Enhance V1 responses with error detection
              this.enhanceV1ResponseWithErrorHandling(searchValue);

              this.transformedData = { searchResults: searchValue };
              this.llmReqId = res?.llm_data?.req_id || '';
              this.createdOn = res?.llm_data?.created_at || '';
            });
          }
        },
        error: (error) => {
          this.errorHandling(addressData, error);
        },
      });
    }
  }

  searchMissedPickup(): void {
    const { queryParam, addressData } = this.prepareMissedPickupForSearch();
    const addressWithoutCommas = queryParam.address.replace(/,/g, '').toUpperCase();
    this.api_service.missedPickup(addressWithoutCommas, queryParam.type, queryParam.date.toISOString().split('T')[0]).pipe(
      takeUntil(this.unsubscribeAll),
    ).subscribe((data) => {
      this.isLoading = false;
      this.mpuData = data;
      console.log(data);
      this.llmMpuReqId = data.body.requestId;
      console.log(this.llmMpuReqId);
      // if (this.mpuData) {
      //   this.transformBooleanToYesNO(this.mpuData.body.agentAnswer);
      // }
      this.transformMpuData();
    }, (error) => {
      this.errorHandling(addressData, error);
    });
  }

  formatServiceChangeAnswer(data: any): string {
    let answer = '';

    if (data.solid_waste) {
      const formattedText = data.solid_waste.replace(/^(Solid Waste:)\s*(.*)/, '$1\n$2');
      answer += `${formattedText}\n\n`;
    }

    if (data.recycle) {
      const formattedText = data.recycle.replace(/^(Recycle:)\s*(.*)/, '$1\n$2');
      answer += `${formattedText}\n\n`;
    }

    if (data.yard_waste_organics_manure) {
      const formattedText = data.yard_waste_organics_manure.replace(/^(Yard Waste:)\s*(.*)/, '$1\n$2');
      answer += `${formattedText}\n\n`;
    }

    // Handle any additional service types
    Object.keys(data).forEach((key) => {
      if (key !== 'recycle' && key !== 'solid_waste' && key !== 'yard_waste_organics_manure' && data[key]) {
        // Try to match common patterns for service headings
        const formattedText = data[key].replace(/^([A-Za-z\s]+:)\s*(.*)/, '$1\n$2');
        answer += `${formattedText}\n\n`;
      }
    });

    return answer.trim();
  }

  searchServiceChange(): void {
    if (this.isV2Mode() && this.v2GisResponse) {
      // Use V2 KMT service
      this.kmtService.getServiceChange(
        this.v2GisResponse.polygon,
        this.v2GisResponse.division,
        this.v2GisResponse.lawson,
      ).pipe(
        takeUntil(this.unsubscribeAll),
      ).subscribe({
        next: (data: V2ServiceChangeResponseUnion) => {
          if (this.isV2ErrorResponse(data)) {
            // Handle as error even though it came through 'next'
            const serviceChangeAddressData = this.prepareServiceChangeForSearch();
            this.handleV2Error(data, serviceChangeAddressData);
            return;
          }

          if (!this.isV2ServiceChangeResponse(data)) {
            const serviceChangeAddressData = this.prepareServiceChangeForSearch();
            this.errorHandling(serviceChangeAddressData, { error: { message: 'Invalid response format' } } as HttpErrorResponse);
            return;
          }

          // Existing success handling
          this.isLoading = false;
          // Transform V2 response to match V1 format for UI compatibility
          this.serviceChangeData = {
            statusCode: 200,
            body: {
              requestId: data.metadata?.request_id || '',
              polygon: data.metadata?.polygon || '',
              llmResponse: [{
                Question: 'What service information is available?',
                Answer: this.formatServiceChangeAnswer(data.data),
              }],
            },
          };
          console.log('V2 Service Change Response');
          console.log(this.serviceChangeData);
          this.llmScReqId = data.metadata?.request_id || '';
          this.createdOn = data.metadata?.created_at || '';
          console.log(this.llmScReqId);
        },
        error: (error: any) => {
          const serviceChangeAddressData = this.prepareServiceChangeForSearch();
          this.errorHandling(serviceChangeAddressData, error);
        },
      });
    } else {
      // Use V1 service for backward compatibility
      const addressData = this.prepareServiceChangeForSearch();
      console.log(addressData);
      this.api_service.serviceChange(addressData).pipe(
        takeUntil(this.unsubscribeAll),
      ).subscribe((data: any) => {
        this.isLoading = false;
        this.serviceChangeData = data;
        console.log('V1 Service Change Response');
        console.log(this.serviceChangeData);
        this.llmScReqId = data.body.requestId;
        this.createdOn = data?.body?.created_at || '';
        console.log(this.llmScReqId);
      }, (error: any) => {
        const v1AddressData = this.prepareServiceChangeForSearch();
        this.errorHandling(v1AddressData, error);
      });
    }
  }

  transformMpuData() {
    const agentAnswer = this.mpuData?.body?.agentAnswer;

    if (agentAnswer) {
      this.invalidFlag = null;
      if (!agentAnswer.isAccountActive) {
        this.invalidFlag = 'This is not a valid MPU because the account was not active at the time of service';
      } else if (!agentAnswer.activeContainersOnAccount) {
        this.invalidFlag = 'This is not a valid MPU because the container was not active';
      } else if (!agentAnswer.isContainerOnPickUpSchedule) {
        this.invalidFlag = 'This is not a valid MPU due to the container not being on the pickup schedule';
      } else if (agentAnswer.isContainerBlocked) {
        this.invalidFlag = 'This is not a valid MPU due to the container being blocked';
      } else if (agentAnswer.isContainerContaminated) {
        this.invalidFlag = 'This is not a valid MPU because container had contaminated materials in it';
      } else if (agentAnswer.isContainerOverfilled) {
        this.invalidFlag = 'This is not a valid MPU due to overage';
      } else if (agentAnswer.isContainerLocked) {
        this.invalidFlag = 'This is not a valid MPU due to the container was locked';
      } else if (agentAnswer.isContainerNotPlacedOut) {
        this.invalidFlag = 'This is not a valid MPU due to the container not being placed out';
      }
    }
  }

  errorHandling(addressData?: string | null, error?: HttpErrorResponse) {
    this.isLoading = false;
    this.initialFormValue = [];

    if (addressData == null) {
      this.openToastrShow('Invalid or incomplete address');
      return;
    }

    // Handle the new structured error response
    let errorMessage = 'An unexpected error occurred';

    if (error?.error && this.isV2ErrorResponse(error.error)) {
      // New V2 error format
      errorMessage = this.getV2ErrorMessage(error.error);
    } else if (error?.error?.message) {
      // Legacy V1 error format
      errorMessage = error.error.message;
    } else if (error?.message) {
      // HTTP error message
      errorMessage = error.message;
    }

    this.openToastrShow(errorMessage);
  }

  private isV2ErrorResponse(errorBody: any): errorBody is V2ErrorResponse {
    return errorBody?.error?.code && errorBody?.error?.message && errorBody?.request_id;
  }

  private getV2ErrorMessage(errorResponse: V2ErrorResponse): string {
    const { code, message } = errorResponse.error;

    switch (code) {
      case 'VALIDATION_ERROR':
        return `Input Error: ${message}`;
      case 'PROCESSING_ERROR':
        return `Processing Error: ${message}`;
      case 'SERVICE_ERROR':
        return `Service Error: ${message}`;
      default:
        return `Error: ${message}`;
    }
  }

  private handleV2Error(errorResponse: V2ErrorResponse, _addressData?: string | null) {
    this.isLoading = false;
    this.initialFormValue = [];
    const errorMessage = this.getV2ErrorMessage(errorResponse);
    this.openToastrShow(errorMessage);
  }

  // Type guards for response validation
  private isV2BulkResponse(response: V2BulkResponseUnion): response is V2BulkResponse {
    return !!(response as V2BulkResponse)?.data && !this.isV2ErrorResponse(response);
  }

  private isV2ExtraPickupResponse(
    response: V2ExtraPickupResponseUnion,
  ): response is V2ExtraPickupResponse {
    return !!(response as V2ExtraPickupResponse)?.data && !this.isV2ErrorResponse(response);
  }

  private isV2ServiceChangeResponse(
    response: V2ServiceChangeResponseUnion,
  ): response is V2ServiceChangeResponse {
    return !!(response as V2ServiceChangeResponse)?.data && !this.isV2ErrorResponse(response);
  }

  searchExtraPickup(): void {
    const {
      queryParam, searchValue, addressData, gisData,
    } = this.prepareDataForSearch();

    if (this.isV2Mode()) {
      // Use v2 KMT API for extra pickup
      const services = this.typeDetails().map((type) => type.name?.toLowerCase() || '');

      this.kmtService.getExtraPickupItems(
        gisData.polygon,
        gisData.division,
        gisData.lawson,
        services,
      ).pipe(
        takeUntil(this.unsubscribeAll),
      ).subscribe({
        next: (data: V2ExtraPickupResponseUnion) => {
          if (this.isV2ErrorResponse(data)) {
            // Handle as error even though it came through 'next'
            this.handleV2Error(data, addressData);
            return;
          }

          if (!this.isV2ExtraPickupResponse(data)) {
            this.errorHandling(addressData, { error: { message: 'Invalid response format' } } as HttpErrorResponse);
            return;
          }

          // Existing success handling
          this.isLoading = false;
          console.log('V2 Extra Pickup Response:', data);

          // Transform v2 response to match current UI expectations
          this.transformV2ExtraPickupData(data, searchValue);
          this.llmReqId = data?.metadata?.request_id || '';
          this.createdOn = data?.metadata?.created_at || '';
        },
        error: (error) => {
          this.errorHandling(addressData, error);
        },
      });
    } else {
      // Use v1 API
      this.extraPickupService.getItemList(queryParam).pipe(
        takeUntil(this.unsubscribeAll),
      ).subscribe((data) => {
        if (data) {
          this.isLoading = false;
          const res = data as unknown as RawData;
          this.api_service.transformData(res).subscribe((transformed) => {
            Object.keys(transformed.searchResults).forEach((key) => {
              if (transformed.searchResults[key.toLowerCase()]) {
                searchValue[key] = transformed.searchResults[key];
              } else {
                console.log('fail');
              }
            });

            Object.keys(searchValue).forEach((searchItemKey) => {
              const searchItem = searchValue[searchItemKey];

              searchItem.sort((first: object, second: object) => {
                if ('is_extra_pickup_available' in first) return -1;
                if ('is_extra_pickup_available' in second) return 1;
                return 0;
              });
            });

            // Enhance extra pickup V1 responses with error detection
            this.enhanceV1ResponseWithErrorHandling(searchValue);

            this.transformedData = { searchResults: searchValue };
            this.llmReqId = res?.llm_data?.req_id || '';
            this.createdOn = res?.llm_data?.created_at || '';
          });
        }
      }, (error) => {
        this.errorHandling(addressData, error);
      });
    }
  }

  feedBack(value: string, item: string): void {
    const itemName = item;
    console.log(itemName);
    this.feedBackStatus[item] = { isFeedBack: '' };

    if (this.isV2Mode()) {
      // Use v2 feedback API
      const feedbackRequest: V2FeedbackRequest = {
        req_id: this.llmReqId,
        feedback: value === 'true',
        item: itemName,
      };
      console.log('V2 Feedback Request:', feedbackRequest);

      this.kmtService.sendFeedback(feedbackRequest).pipe(
        takeUntil(this.unsubscribeAll),
      ).subscribe({
        next: (res) => {
          if (res && res.status === 'success') {
            this.feedBackStatus[item] = { isFeedBack: value === 'true' ? 'true' : 'false' };
          }
        },
        error: (error) => {
          console.error('V2 Feedback error:', error);
        },
      });
    } else {
      // Use v1 feedback API
      const queryParam = {
        feedback: value,
        req_id: this.llmReqId,
        created_at: this.createdOn,
        item: itemName,
      };
      console.log(queryParam);

      this.api_service.setFeedback(queryParam).pipe(
        takeUntil(this.unsubscribeAll),
      ).subscribe(((res) => {
        if (res) {
          this.feedBackStatus[item] = { isFeedBack: value === 'true' ? 'true' : 'false' };
        }
      }));
    }
  }

  mpuFeedBack(value: string, item: string): void {
    const itemName = item;
    const createdAt: string = new Date().toLocaleString();
    console.log(itemName);
    if (value === 'true') {
      this.selectedThumb = 'up'; // Select thumbs up when clicked
    } else {
      this.selectedThumb = 'down'; // Select thumbs down when clicked
    }
    // this.feedBackStatus[item] = { isFeedBack: '' };

    const queryParam = {
      feedback: value,
      req_id: this.llmMpuReqId,
      created_at: createdAt,
      item: itemName,
    };
    console.log(queryParam);

    this.api_service.setFeedback(queryParam).pipe(
      takeUntil(this.unsubscribeAll),
    ).subscribe(((res) => {
      console.log(res);
    }));
  }

  serviceChangeFeedBack(value: string, item: string = 'NA'): void {
    if (value === 'true') {
      this.selectedThumb = 'up'; // Select thumbs up when clicked
    } else {
      this.selectedThumb = 'down'; // Select thumbs down when clicked
    }

    if (this.isV2Mode()) {
      // Use v2 feedback API (same pattern as bulk/extra pickup)
      const feedbackRequest: V2FeedbackRequest = {
        req_id: this.llmScReqId,
        feedback: value === 'true',
        item,
      };
      console.log('V2 Service Change Feedback Request:', feedbackRequest);

      this.kmtService.sendFeedback(feedbackRequest).pipe(
        takeUntil(this.unsubscribeAll),
      ).subscribe({
        next: (res) => {
          console.log('V2 Service Change Feedback Response:', res);
          if (res && res.status === 'success') {
            console.log('Service change feedback submitted successfully');
          } else {
            console.warn('V2 Service Change Feedback failed:', res);
          }
        },
        error: (error) => {
          console.error('V2 Service Change Feedback error:', error);
          console.error('Error details:', {
            status: error.status,
            message: error.message,
            body: error.error,
          });
        },
      });
    } else {
      // Use v1 feedback API for backward compatibility
      const queryParam = {
        feedback: value,
        req_id: this.llmScReqId,
        created_at: this.createdOn,
        item,
      };
      console.log('V1 Service Change Feedback Request:', queryParam);

      this.api_service.setFeedback(queryParam).pipe(
        takeUntil(this.unsubscribeAll),
      ).subscribe((res) => {
        console.log('V1 Service Change Feedback Response:', res);
      });
    }
  }

  clearSearch(): void {
    this.searchForm.patchValue({
      searchTerm: '',
    });
    this.disabledItems.fill(false);
    this.typeDetails.update(() => []);
    this.initialFormValue = [];
    this.transformedData.searchResults = {};
    this.mpuData = undefined;
    this.serviceChangeData = undefined;
  }

  // eslint-disable-next-line class-methods-use-this
  filterResults(): string[] {
    return this.items;
  }

  add(event: MatChipInputEvent): void {
    // Convert the items in the array to lowercase
    const lowerCaseItems = this.selectionOption() === 'bulk-pickup'
      ? this.items.map((item) => item.toLowerCase())
      : this.extraPickupItems.map((item) => item.toLowerCase());

    // Convert the event.value to lowercase
    const lowerCaseValue = event.value.toLowerCase();

    // Find the index of the lowercase value in the lowercase items array
    const index = lowerCaseItems.indexOf(lowerCaseValue);

    if (index !== -1) {
      // Disable the item if it exists
      this.disabledItems[index] = true;
    }
    const value = (event.value).trim();
    const old = this.typeDetails();
    // Check if the item already exists based on the `name` property
    const ex = old.some((val) => val.name?.toLocaleLowerCase() === event.value.toLocaleLowerCase());
    if (!ex && value) {
      this.typeDetails.update((type) => [...type, { name: value }]);
      setTimeout(() => {
        this.searchForm.patchValue({
          searchTerm: [],
        });
        this.searchForm.patchValue({
          searchTerm: this.typeDetails(),
        });
        if (this.typeDetails().length > 10) {
          this.remove(this.typeDetails()[0]);
        }
      }, 3000);
    } else if (value !== '' || ex) {
      this.openToastrShow('Item you are trying to add already exist');
      return;
    }

    const input = event.input as HTMLInputElement;
    if (input) {
      input.value = '';
    }
  }

  remove(type: FormData): void {
    const lowerCaseItems = this.selectionOption() === 'bulk-pickup'
      ? this.items.map((item) => item.toLowerCase())
      : this.extraPickupItems.map((item) => item.toLowerCase());

    const indexes = lowerCaseItems.findIndex(
      (existing) => existing === type.name?.toLocaleLowerCase(),
    );

    // Check if the item exists
    if (indexes !== -1) {
      // Update the disabled state to false for the item
      this.disabledItems[indexes] = false;
    }
    this.typeDetails.update((types) => {
      const index = types.indexOf(type);
      if (index < 0) {
        return types;
      }

      types.splice(index, 1);
      this.announcer.announce(`Removed ${type}`);
      return [...types];
    });
    if (!this.typeDetails().length) {
      this.searchForm.patchValue({
        searchTerm: '',
      });
    }
  }

  edit(type: FormData, value: string) {
    // Edit existing type
    // Convert the items in the array to lowercase
    const lowerCaseItems = this.items.map((item) => item.toLowerCase());

    // Convert the event.value to lowercase
    const lowerCaseValue = value.toLowerCase();

    // Find the index of the lowercase value in the lowercase items array
    const index = lowerCaseItems.indexOf(lowerCaseValue);

    if (index !== -1) {
      // Disable the item if it exists
      this.disabledItems[index] = true;
    }
    const old = this.typeDetails();

    // Check if the item already exists based on the `name` property
    const ex = old.some((val) => val.name?.toLocaleLowerCase() === value.toLocaleLowerCase());
    if (!ex && value) {
      this.typeDetails.update((types) => {
        const indexes = types.indexOf(type);
        if (indexes >= 0) {
          const typess = types as FormData[];
          typess[index].name = value;
          return [...typess];
        }
        return types;
      });
    } else if (value !== '' || ex) {
      this.openToastrShow('Item you are trying to add already exist');
    }
  }

  transformV2BulkData(v2Response: V2BulkResponse, searchValue: any): void {
    // Transform v2 response format to match existing UI expectations with consistent field ordering
    const updatedSearchValue = { ...searchValue };

    // Define the consistent field order for bulk items (V2 format with underscores)
    const bulkFieldOrder = [
      'is_acceptable',
      'size_weight', // V2 uses underscore instead of slash
      'service_limit',
      'service_frequency',
      'schedule_advance',
      'prepayment',
      'preparation',
      'charges_fees', // V2 uses underscore instead of slash
    ];

    Object.keys(v2Response.data).forEach((itemKey) => {
      const itemData = v2Response.data[itemKey];
      const transformedItem: Array<{ [key: string]: { Generated_Response: string } }> = [];

      // Check if this item has error responses (new item-level error handling)
      const hasItemErrors = this.detectItemErrors(itemData);

      if (hasItemErrors) {
        // Handle item-level errors: show error information prominently
        this.processItemErrors(itemData, transformedItem, bulkFieldOrder);
      } else {
        // Check if item is unacceptable first
        const isAcceptableResponse = itemData.is_acceptable;
        const acceptanceStatus = isAcceptableResponse ? this.getAcceptanceStatus(isAcceptableResponse) : '';
        const isUnacceptable = acceptanceStatus === 'Not Acceptable';

        // If item is unacceptable, only include the is_acceptable field (matching V1 behavior)
        if (isUnacceptable) {
          transformedItem.push({
            is_acceptable: {
              Generated_Response: this.cleanV2ResponseText(isAcceptableResponse || ''),
            },
          });
        } else {
          // For acceptable and conditional items, include all fields as before
          bulkFieldOrder.forEach((fieldKey) => {
            const fieldValue = itemData[fieldKey as keyof typeof itemData];
            if (fieldValue) { // Only add fields that have truthy values
              transformedItem.push({
                [fieldKey]: {
                  Generated_Response: this.cleanV2ResponseText(fieldValue),
                },
              });
            }
          });

          // Add any additional fields that might not be in our predefined order
          Object.keys(itemData).forEach((fieldKey) => {
            if (!bulkFieldOrder.includes(fieldKey)) {
              const fieldValue = itemData[fieldKey as keyof typeof itemData];
              if (fieldValue) { // Only add fields that have truthy values
                transformedItem.push({
                  [fieldKey]: {
                    Generated_Response: this.cleanV2ResponseText(fieldValue),
                  },
                });
              }
            }
          });
        }
      }

      updatedSearchValue[itemKey.toLowerCase()] = transformedItem;
    });

    this.transformedData = { searchResults: updatedSearchValue };
  }

  /**
   * Detect if an item/service has error responses from the backend
   */
  detectItemErrors(itemData: any): boolean {
    if (!itemData) return false;

    // Check if any field contains error messages
    return Object.values(itemData).some((value: any) => {
      if (typeof value === 'string') {
        return value.startsWith('Error:')
               || value.includes('ValidationError')
               || value.includes('ProcessingError')
               || value.includes('ServiceError')
               || value.includes('UnknownError');
      }
      return false;
    });
  }

  /**
   * Process item-level errors and format them for display
   */
  processItemErrors(
    itemData: any,
    transformedItem: Array<{ [key: string]: { Generated_Response: string } }>,
    fieldOrder: string[],
  ): void {
    // Find the first error to determine error type and message
    let errorType = 'Error';
    let errorMessage = 'An error occurred processing this item';

    Object.entries(itemData).forEach(([_fieldKey, fieldValue]) => {
      if (typeof fieldValue === 'string' && fieldValue.startsWith('Error:')) {
        const errorMatch = fieldValue.match(/Error: (\w+) - (.+)/);
        if (errorMatch) {
          [, errorType, errorMessage] = errorMatch;
        }
      }
    });

    // Create error display entry as the first field
    transformedItem.push({
      error_status: {
        Generated_Response: `${errorType}: ${errorMessage}`,
      },
    });

    // Still show other fields that might have partial data or error details
    fieldOrder.forEach((fieldKey) => {
      const fieldValue = itemData[fieldKey as keyof typeof itemData];
      if (fieldValue && typeof fieldValue === 'string') {
        transformedItem.push({
          [fieldKey]: {
            Generated_Response: this.cleanV2ResponseText(fieldValue),
          },
        });
      }
    });
  }

  /**
   * Enhance V1 responses with error detection and handling
   */
  enhanceV1ResponseWithErrorHandling(searchValue: any): void {
    if (!searchValue) return;

    Object.keys(searchValue).forEach((itemKey) => {
      const itemResults = searchValue[itemKey];
      if (Array.isArray(itemResults)) {
        itemResults.forEach((result) => {
          if (result && typeof result === 'object') {
            // Check each field in the result for error messages
            Object.keys(result).forEach((fieldKey) => {
              const fieldData = result[fieldKey];
              if (fieldData && fieldData.Generated_Response) {
                const response = fieldData.Generated_Response;
                if (typeof response === 'string' && this.containsErrorMessage(response)) {
                  // Mark this field as containing an error for UI styling
                  fieldData.IsError = true;
                  fieldData.ErrorType = this.extractErrorType(response);
                }
              }
            });
          }
        });
      }
    });
  }

  /**
   * Check if a response string contains error messages
   */
  containsErrorMessage(response: string): boolean {
    if (!response) {
      return false;
    }
    return response.startsWith('Error:')
           || response.includes('ValidationError')
           || response.includes('ProcessingError')
           || response.includes('ServiceError')
           || response.includes('UnknownError');
  }

  /**
   * Extract error type from error message
   */
  extractErrorType(response: string): string {
    const errorMatch = response.match(/Error: (\w+) - (.+)/);
    return errorMatch ? errorMatch[1] : 'Error';
  }

  transformV2ExtraPickupData(v2Response: V2ExtraPickupResponse, searchValue: any): void {
    // Transform v2 response format to match existing UI expectations with consistent field ordering
    const updatedSearchValue = { ...searchValue };

    // Define the consistent field order for extra pickup items (same as V1)
    const extraPickupFieldOrder = [
      'is_extra_pickup_available',
      'service_level_waste_stream',
      'service_limit',
      'charge_codes',
      'schedule_advance',
      'prepayment',
    ];

    Object.keys(v2Response.data).forEach((itemKey) => {
      const itemData = v2Response.data[itemKey];
      const transformedItem: Array<{ [key: string]: { Generated_Response: string } }> = [];

      // Check if this service has error responses (new service-level error handling)
      const hasServiceErrors = this.detectItemErrors(itemData);

      if (hasServiceErrors) {
        // Handle service-level errors: show error information prominently
        this.processItemErrors(itemData, transformedItem, extraPickupFieldOrder);
      } else {
        // Transform fields in the defined order to ensure consistency across all items
        extraPickupFieldOrder.forEach((fieldKey) => {
          const fieldValue = itemData[fieldKey as keyof typeof itemData];
          if (fieldValue !== undefined) { // Only add fields that exist in the response
            transformedItem.push({
              [fieldKey]: {
                Generated_Response: this.cleanV2ResponseText(fieldValue || ''),
              },
            });
          }
        });

        // Add any additional fields that might not be in our predefined order
        Object.keys(itemData).forEach((fieldKey) => {
          if (!extraPickupFieldOrder.includes(fieldKey)) {
            const fieldValue = itemData[fieldKey as keyof typeof itemData];
            transformedItem.push({
              [fieldKey]: {
                Generated_Response: this.cleanV2ResponseText(fieldValue || ''),
              },
            });
          }
        });
      }

      updatedSearchValue[itemKey.toLowerCase()] = transformedItem;
    });

    this.transformedData = { searchResults: updatedSearchValue };
  }

  clearAddress() {
    this.searchForm.patchValue({
      addressterm: '',
    });
    this.gisResponse = {
      polygon: '',
      lawson: '',
      division: '',
      success: false,
    };
    this.v2GisResponse = null;
    this.gisResolved = false;
  }

  getItemNames(): string[] {
    return Object.keys(this.transformedData.searchResults || {});
  }

  getFieldKeys(resultItem: ParallelResultItem) {
    return Object.keys(resultItem);
  }

  getAcceptanceStatus(response: string): string {
    this.dummyProperty = 'test';
    // const parts = response.split('.');
    // const lastPart = parts[parts.length - 1].trim(); // Get the last part
    const index = response.indexOf('.');
    const beforeFullStop = index !== -1 ? response.substring(0, index) : response;
    if (beforeFullStop.trim().toLowerCase() === 'acceptable') {
      return 'Acceptable';
    }
    if (beforeFullStop.trim().toLowerCase() === 'not-acceptable'
      || beforeFullStop.trim().toLowerCase() === 'not acceptable') {
      return 'Not Acceptable';
    }
    if (beforeFullStop.trim() !== 'not-acceptable'
      && beforeFullStop.trim() !== 'acceptable' && beforeFullStop.trim() !== 'not acceptable') {
      return 'Conditional';
    }
    return ''; // Return an empty string or a default message if neither
  }

  getFullText(input: string): string {
    return input.trim();
  }

  // Helper function to remove HTML comments with incomplete multi-character sanitization protection
  removeHtmlComments(input: string): string {
    // Remove all '<' and '>' characters to eliminate HTML tags and comment fragments
    return input.replace(/<|>/g, '').trim();
  }

  // Helper function to clean V2 response text by removing XML-like tags and HTML comments
  private cleanV2ResponseText(text: string): string {
    if (!text) return text;

    // First remove HTML comments to prevent incomplete multi-character sanitization
    let cleanedText = this.removeHtmlComments(text);

    // Then repeatedly remove XML-like tags
    // (e.g., <item>Mattress</item> becomes just the content inside)
    // This handles nested tags properly by repeating until no more tags are found
    let previous: string;
    do {
      previous = cleanedText;
      cleanedText = cleanedText.replace(/<[^>]*>/g, '');
    } while (cleanedText !== previous);

    return cleanedText.trim();
  }

  getDisplayName(key: string): string {
    this.dummyProperty = 'test';
    const displayNames: { [key: string]: string } = {
      // V1 Bulk fields (with slashes)
      is_acceptable: 'Acceptability',
      'size/weight': 'Size/Weight Restrictions',
      'charges/fees': 'Rates',

      // V2 Bulk fields (with underscores)
      size_weight: 'Size/Weight Restrictions',
      charges_fees: 'Rates',

      // Common bulk fields
      service_limit: 'Service Limit',
      service_frequency: 'Service Frequency',
      schedule_advance: 'Advance Scheduling',
      prepayment: 'Pre-payment',
      preparation: 'Preparation',

      // Additional field mappings
      charge_codes: 'Rates',

      // Extra pickup fields
      service_level_waste_stream: 'Included Service',
      is_extra_pickup_available: 'Extra Pickup Available',
    };

    return displayNames[key] || key; // Return the mapped name or the original key if not found
  }

  isErrorRoute(): boolean {
    return this.router.url === '/error';
  }

  preventTyping(event: KeyboardEvent) {
    event.preventDefault();
  }
}
